import content_ad_list from './ad-list';
import content_ad_add from './ad-add';
import content_ad_edit from './ad-edit';
import content_ad_detail from './ad-detail';

export default {
    content_ad_list,
    content_ad_add,
    content_ad_edit,
    content_ad_detail,
};
